<template>
  <cc-container class="bind_account">
      <cc-header-nav title="账号绑定">
      </cc-header-nav>
     <cc-main id="container">
       <van-row>
        <van-col span="24" class="bind-container">
          <div>
            <img
              src="../../assets/img/bind-account/WeChat.png"
              alt=""
                style="width: 0.25rem;padding:18px;padding-top:15px;"
            />
          </div>
          <p class="weChat_text">微信</p>
            <p class="binding" @click="binding()" v-if="is_bind === '1'">已绑定</p>
            <p class="on_binding" @click="no_bound()" v-if="is_bind === '0'">未绑定</p>
          <van-icon name="arrow" class="right_icon"/>
        </van-col>
      </van-row>
      <van-row>
      <van-col  span="24">
        <p class="bind_details ">账号绑定之后用户可以用微信号快速登录采购平台</p>
      </van-col>
      </van-row>
    </cc-main>
  </cc-container>
</template>

<script>
import Vue from 'vue'
// import { mapActions, mapGetters } from 'vuex'
import { getUnbindall, getBind } from '../../fetch/bind-account'
import { Lazyload, Dialog, Icon, Toast, Row, Col } from 'vant'
// import { types } from '../../store/modules/bind-account'
Vue.use(Lazyload)
  .use(Dialog)
  .use(Icon)
  .use(Toast)
  .use(Row)
  .use(Col)
export default {
  name: 'bind_account',
  data () {
    return {
      is_bind: '0'
    }
  },
  mounted: function () {
    this.BindingWeChat()
  },
  methods: {
    async BindingWeChat () {
      var res = await getUnbindall()
      this.is_bind = res.data.is_bind + ''
    },
    binding () {
      Dialog.confirm({
        title: '微信账号解绑确定',
        message: '您确定解除微信账号绑定吗？'
      }).then(async success => {
        await getBind()
        this.is_bind = '0'
        Toast('解绑成功')
      }).catch(calcel => {
      })
    },
    no_bound () {
      var wx = navigator.userAgent.toLowerCase()
      if (wx.match(/MicroMessenger/i)) {
        window.location.href = '/visitor/wechat-login'
        // this.$router.push('/visitor/wechat-login')
      } else {
        Toast('浏览器不支持第三方登录')
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/index.scss';
.bind_account{
  #container {
    .bind-container{
      background: #fff;
      height: 50px;
      border-bottom: 1px solid #e5e5e5;
      display: inline-block;
    }
    .weChat_text{
      font-size: 12px;
      color: #333333;
      text-align: left;
      margin-top: -38px;
      padding-left: 65px;
    }
    .binding,.on_binding{
      font-size: 12px;
      color: #777777;
      text-align:right;
      margin-top: -15px;
      padding-right:50px;
    }
    .on_binding{
      color: #EE3030;
    }
    .right_icon{
      font-size: 12px;
      float: right;
      margin-top: -13px;
      padding-right: 20px;
      color: #8F8F8F;
    }
  }
  .bind_details{
    text-align: center;
    margin-top: 25px;
  }
}
</style>
